<div id="settings">
  <div class="page-margin-top page-margin-bottom">
    <gridview classes="w-100 m-0">
      <gridview-row>
        <columntemplate classes="pl-0 page-margin-left">
          <h1 class="text-uppercase">{{strings.Settings}}</h1>
        </columntemplate>
      </gridview-row>
      <gridview-row classes="">
        <columntemplate classes="pl-0">
          <gridview-row classes="ml-0">
            <columntemplate classes="column-style pl-0 page-margin-left mr-4" size="auto">
              <user-profile></user-profile>
            </columntemplate>
            <columntemplate classes="settings-border hide-spacer" size="auto">
              <gridview-row classes="">
                <div class="spacer page-margin-left"></div>
                <columntemplate classes="column-style pl-0">
                  <user-settings></user-settings>
                  <div id="administration" *ngIf="showAdminSection">
                    <h3 class="text-uppercase">{{strings.Administration}}</h3>
                    <div class="label-control text-break">
                      <span class="pm-color-darker">{{strings.Database}}:</span>
                      <span class="pl-2 font-italic"> {{databaseConnectionInfo}}</span>
                    </div>
                    <div class="container-fluid">
                      <div class="row">
                        <button class="col-auto btn btn-primary d-block" (click)="reloadCaches()">{{strings.ReloadCaches}}</button>
                      </div>
                      <div class="row">
                        <button class="col-auto btn btn-primary" (click)="reloadUserCaches()">{{strings.ReloadUserData}}</button>
                      </div>
                    </div>
                  </div>
                  <!-- Customization -->
                  <div id="bomChangeManagement" *ngIf="showSimulateBomChanges">
                    <h3 class="text-uppercase">BOM Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productBomView">
                      </dropdown>

                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('bom')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformBomChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('bom')">Perform changes</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformBomChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmScheduleChangeClick('bom')">Schedule</button>
                      </div>
                    </div>
                    <div class="row" *ngIf="showPerformBomChanges">
                      <scheduled-changes-list #bomScheduledChangesList class="col-auto w-100" [type]="'bom'" (onRemoveScheduledChanges)="onRemoveScheduledPerformChanges($event)"></scheduled-changes-list>
                    </div>
                  </div>

                  <div id="priceChangeManagement" *ngIf="showSimulatePriceChanges">
                    <h3 class="text-uppercase">Price Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productPriceView"
                                (onValueChange)="onProductSelectionChange()">
                      </dropdown>
                    </div>
                    <div class="row">
                      <dropdown *ngIf="priceListCategoriesView != null"
                                class="col-auto"
                                [itemsView]="priceListCategoriesView"
                                [view]="priceListCategoryView">
                      </dropdown>
                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('price')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformPriceChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('price')">Perform changes</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformPriceChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmScheduleChangeClick('price')">Schedule</button>
                      </div>
                    </div>
                    <div class="row" *ngIf="showPerformPriceChanges">
                      <scheduled-changes-list #priceScheduledChangesList class="col-auto w-100" [type]="'price'" (onRemoveScheduledChanges)="onRemoveScheduledPerformChanges($event)"></scheduled-changes-list>
                    </div>
                  </div>

                  <div id="compStringChangeManagement" *ngIf="showSimulateCompStringChanges">
                    <h3 class="text-uppercase">Comparison String Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productCompStringView">
                      </dropdown>
                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('compstring')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformCompStringChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('compstring')">Perform changes</button>
                      </div>
                    </div>
                  </div>

                  <div id="attributeChangeManagement" *ngIf="showSimulateAttributeChanges">
                    <h3 class="text-uppercase">Attribute Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productAttributeView">
                      </dropdown>
                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('attribute')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformAttributeChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('attribute')">Perform changes</button>
                      </div>
                    </div>
                  </div>

                  <div id="catprodinfoChangeManagement" *ngIf="showSimulateCatProdInfoChanges">
                    <h3 class="text-uppercase">Catalogue Product Info Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productCatProdInfoView">
                      </dropdown>
                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('catprodinfo')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformCatProdInfoChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('catprodinfo')">Perform changes</button>
                      </div>
                    </div>
                  </div>

                  <div id="jeevesprodinfoChangeManagement" *ngIf="showSimulateJeevesProdInfoChanges">
                    <h3 class="text-uppercase">Jeeves Product Info Change Management</h3>
                    <div class="row">
                      <dropdown *ngIf="productsView != null"
                                class="col-auto"
                                [itemsView]="productsView"
                                [view]="productJeevesProdInfoView">
                      </dropdown>
                      <div class="col-auto align-middle">
                        <button class="btn btn-primary d-block" (click)="onSimulateChangesClick('jeevesprodinfo')">Simulate</button>
                      </div>
                      <div class="col-auto align-middle" *ngIf="showPerformCatProdInfoChanges">
                        <button class="btn btn-primary d-block" (click)="onConfirmPerformChangesClick('jeevesprodinfo')">Perform changes</button>
                      </div>
                    </div>
                  </div>
                  <!-- End customization -->
                </columntemplate>
              </gridview-row>
            </columntemplate>
          </gridview-row>
        </columntemplate>
      </gridview-row>
    </gridview>
  </div>
</div>

<!-- Customization -->
<a #downloadLink style="display:none;"></a>
<message-box (okClick)="onPerformChangesClick($event)" [title]="strings.Confirm" [okButtonText]="strings.Yes" [cancelButtonText]="strings.No"></message-box>
<schedule-change-popup (onOkClick)="onPerformScheduleChangeClick($event)"></schedule-change-popup>